<div class="modal-header">
    <h4 class="modal-title pull-left" translate>{{title}}</h4>
</div>
<div class="modal-body ng-workflow-add-block">
    <div class="add-task--actions cs-d-flex flex-column">
        <div class="cs-helper-section bg-white cs-border cs-border--bottom">
            <div class="cs-help-text-color p--15" translate [translateParams]="{objectName:objectNameDisplayText}">Custom.automation:Add.Action.HelpText</div>
        </div>
        <div class="cs-flex-1">

        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-link" (click)="onCloseModal()">Close</button>
</div>
